"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _liquidjs = require("liquidjs");
var _operators = _interopRequireDefault(require("./operators"));
var _filters = _interopRequireDefault(require("./filters"));
var _tags = _interopRequireDefault(require("./tags"));
var Engine = exports["default"] = /*#__PURE__*/function () {
  function Engine(client) {
    var _client$details, _client$details2, _client$details3;
    if (!client) {
      throw new Error('Engine expects first argument to be a client instance');
    }
    this.client = client;
    this.engine = new _liquidjs.Liquid({
      operators: _operators["default"],
      globals: {
        // client context that can be accessed by filters & tags
        client: {
          details: {
            currencies: client == null || (_client$details = client.details) == null ? void 0 : _client$details.currencies,
            currency: client == null || (_client$details2 = client.details) == null ? void 0 : _client$details2.currency,
            locale: client == null || (_client$details3 = client.details) == null ? void 0 : _client$details3.locale
          },
          get: client == null ? void 0 : client.get
        }
      }
    });
    (0, _filters["default"])(this.engine);
    (0, _tags["default"])(this.engine);
  }

  /**
   * Renders template content with data.
   */
  var _proto = Engine.prototype;
  _proto.render =
  /*#__PURE__*/
  function () {
    var _render = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(content, data) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof content !== 'string')) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", '');
          case 2:
            if (!(content === '')) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", '');
          case 4:
            _context.prev = 4;
            _context.next = 7;
            return this.engine.parseAndRender(content, data);
          case 7:
            return _context.abrupt("return", _context.sent);
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            throw transformError(_context.t0);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[4, 10]]);
    }));
    function render(_x, _x2) {
      return _render.apply(this, arguments);
    }
    return render;
  }()
  /**
   * Returns the template engine.
   */
  ;
  _proto.getEngine = function getEngine() {
    return this.engine;
  };
  return Engine;
}();
/**
 * Scrubs template errors.
 */
function transformError(err) {
  var msg = err.toString();
  if (msg.startsWith('Liquid')) {
    msg = msg.replace(/^Liquid\.[^:]+: /, '').replace('(undefined', '(');
    return new Error(msg);
  } else if (msg.includes('ENOENT')) {
    return new Error('File not found');
  }
  return err;
}